export default {
  title: 'WEBSITE RSVP FORM',
  items: {
    isP2PReservation: {
      label: 'Allow P2P RSVP',
      type: 'boolean'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/website-rsvp-form.js